/* Component Imports */
import { LOCATION_UNAVAILABLE_MESSAGE_LOCALES } from "../../lib/data/allowed-locations";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import {
	Divider,
	MenuItem,
	Select,
	Snackbar,
	SnackbarOrigin,
	styled,
	Tab,
	Tabs,
	useTheme,
	Typography,
	Box,
} from "@mui/material";
import { useRouter } from "next/router";
import React from "react";
import { residential_options_active } from "../../lib/data/search-filters/_e_property_type";
import StateInterface from "../../redux-magic/state-interface";
import { SearchFilterId } from "../../redux-magic/sub-interfaces/search-types";
import {
	setSearchAnimationDetailsThunk,
	setSearchFilterMetricesThunk,
	updateSearchFilterActiveOptionsThunk,
	updateSearchFilterAppliedThunk,
	updateSearchFilterSelectedOptionsThunk,
	updateSearchFilterVisibilityThunk,
} from "../../redux-magic/thunks";
import BeegruButton from "../common-components/buttons/BeegruButton";
import LocationAutoComplete from "./LocationAutoComplete";
import PpsfFilterGenertateUrl from "../../lib/PpsfFilterGenertateUrl";
/* Styled Components */

const MainContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "flex-start",
	justifyContent: "flex-start",
	width: "100%",
	background: "#FFF",
	borderRadius: "0rem 0rem 1rem 1rem",
	// marginTop: "2.375rem",
	padding: "0.5rem 1rem 0.5rem 1rem",
	gap: "1rem",
	[theme.breakpoints.down("sm")]: {
		display: "none",
	},
}));

const FixedWrapper = styled("div")(({ theme }) => ({
	width: "100%",
	display: "flex",
	[theme.breakpoints.up("md1220")]: {
		position: "fixed",
		top: "0",
		left: "50%",
		transform: "translateX(-50%)",
		width: "100%",
		zIndex: 1300,
		// background: "#fff",
		borderRadius: "0.5rem",
		marginTop: "4rem",
		padding: "0rem 4rem 0rem 4rem",
	},
	/* LG breakpoint */
	[theme.breakpoints.only("lg")]: {
		padding: "0rem 4rem 0rem 4rem",
	},
	/* LGPLUS breakpoint */
	[theme.breakpoints.up("lgPlus")]: {
		padding: "0rem 5rem 0rem 5rem",
	},
	[theme.breakpoints.up(1500)]: {
		padding: "0rem 10rem 0rem 10rem",
	},
	[theme.breakpoints.up(1640)]: {
		padding: "0rem 15rem 0rem 15rem",
	},
	[theme.breakpoints.up(1780)]: {
		padding: "0rem 20rem 0rem 20rem",
	},
	/* XL breakpoint */
	[theme.breakpoints.up("xl")]: {
		padding: "0rem 23rem 0rem 23rem",
	},
	[theme.breakpoints.up(2020)]: {
		padding: "0rem 26rem 0rem 26rem",
	},
	[theme.breakpoints.up(2120)]: {
		padding: "0rem 29rem 0rem 29rem",
	},
	[theme.breakpoints.up(2220)]: {
		padding: "0rem 32rem 0rem 32rem",
	},
	[theme.breakpoints.up(2350)]: {
		padding: "0rem 39rem 0rem 39rem",
	},
	/* XXL breakpoint */
	[theme.breakpoints.up("xxl")]: {
		padding: "0rem 36rem 0rem 36rem",
	},
	[theme.breakpoints.up(2800)]: {
		padding: "0rem 39rem 0rem 39rem",
	},
	[theme.breakpoints.up(2900)]: {
		padding: "0rem 40rem 0rem 40rem",
	},
	[theme.breakpoints.up(3000)]: {
		padding: "0rem 42rem 0rem 42rem",
	},
	[theme.breakpoints.up(3100)]: {
		padding: "0rem 47rem 0rem 47rem",
	},
	[theme.breakpoints.up(3200)]: {
		padding: "0rem 52rem 0rem 52rem",
	},
	[theme.breakpoints.up(3300)]: {
		padding: "0rem 57rem 0rem 57rem",
	},
	[theme.breakpoints.up(3400)]: {
		padding: "0rem 62rem 0rem 62rem",
	},
	[theme.breakpoints.up(3500)]: {
		padding: "0rem 67rem 0rem 67rem",
	},
	/* XXXL breakpoint */
	[theme.breakpoints.up("xxxl")]: {
		padding: "0rem 72rem 0rem 72rem",
	},
}));

const SearchTypeTabs = styled(Tabs)({
	display: "flex",
	justifyContent: "center",
	"& .MuiTabs-flexContainer": {
		gap: "3rem",
	},
});

const SearchTypeTab = styled(Tab)(({ theme }) => ({
	display: "flex",
	textTransform: "capitalize",

	lineHeight: "1.5rem",
	"&.MuiTab-root": {
		color: theme.palette.text.secondary,
		fontWeight: 500,
	},
	"&.Mui-selected": {
		color: "#B05911",
		fontWeight: 600,
	},
}));

const SnackbarDiv = styled("div")(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	gap: "8px",
}));

interface State extends SnackbarOrigin {
	open: boolean;
}

/*

* mui select icon props
* data-mui-select-open: a boolean automatically injected by MUI that tells whether the dropdown is open or not.
* className: a string that is used to apply custom styles to the icon.

*/

type IconProps = {
	className?: string;
	"data-mui-select-open"?: boolean;
};

const SearchAfterAnimationComponent = ({
	search_filter_state,
	dispatch,
	searchanimationsettings,
	searchLocation,
}: {
	search_filter_state: StateInterface["search_filters_state"];
	dispatch: Function;
	searchanimationsettings: StateInterface["search_animation_settings"];
	searchLocation: any;
}) => {
	const theme = useTheme();
	const [FilterChanged, setFilterChanged] = React.useState<boolean>(false);
	const [isBeegruAvailable, setIsBeegruAvailable] = React.useState<"available" | "not_available" | "no_location" | "">(
		"",
	);
	const router = useRouter();

	/*

    * No Location Snackbar states

    */

	const [state, setState] = React.useState<State>({
		open: false,
		vertical: "top",
		horizontal: "center",
	});

	const { vertical, horizontal, open } = state;

	const handleClose = () => {
		setState({ ...state, open: false });
		// setIsBeegruAvailable("");
	};

	/*

    * Search Type Tabs and handler function

    */

	const [value, setValue] = React.useState(
		search_filter_state.search_type.selected_options[0].id === "properties"
			? "properties"
			: search_filter_state.search_type.selected_options[0].id === "business_profiles"
				? "agents"
				: "services",
	);
	const ClearAllDefaultFilters = () => {
		/*

						* let's get all the applied filters and store it as string array

					*/
		let filtersapplied: string[] = Object.keys(search_filter_state).filter((key) => {
			const { is_applied } = search_filter_state[key as SearchFilterId] || {};
			if (is_applied) {
				return !["location", "transaction_type", "search_type"].includes(key);
			}
			return false;
		});

		/*

						* let's map the filters applied and update the search filter applied to false and selected options to empty array

					*/
		filtersapplied.map((filter) => {
			dispatch(updateSearchFilterAppliedThunk({ searchFilterId: filter as SearchFilterId, isApplied: false }));
			dispatch(
				updateSearchFilterSelectedOptionsThunk({
					searchFilterId: filter as SearchFilterId,
					newOptions: [],
				}),
			);
			dispatch(
				updateSearchFilterVisibilityThunk({
					searchFilterId: filter as SearchFilterId,
					isVisible: false,
				}),
			);
		});
	};

	const handleChangeSearchTypeTabs = (event: React.SyntheticEvent, newValue: string) => {
		setValue(newValue);
		ClearAllDefaultFilters();
		/*

		* newValue for services and properties

		*/
		if (newValue === "properties") {
			dispatch(
				updateSearchFilterAppliedThunk({
					searchFilterId: "search_type",
					isApplied: true,
				}),
			),
				dispatch(
					updateSearchFilterSelectedOptionsThunk({
						searchFilterId: "search_type",
						newOptions: [
							{
								id: newValue,
								title: newValue.charAt(0).toUpperCase() + newValue.slice(1),
								value: newValue,
							},
						],
					}),
				);
			/*

						* updating service is applied and is visible

						*/
			dispatch(
				updateSearchFilterSelectedOptionsThunk({
					searchFilterId: "service_type",
					newOptions: [],
				}),
			),
				dispatch(
					updateSearchFilterSelectedOptionsThunk({
						searchFilterId: "service_subtype",
						newOptions: [],
					}),
				),
				dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "service_category", isApplied: false }));
			dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "service_type", isApplied: false }));
			dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "service_subtype", isApplied: false }));

			dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "service_category", isVisible: false }));
			dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "service_type", isVisible: false }));
			dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "service_subtype", isVisible: false }));
			/*

						* updating properties is applied and is visible

						*/
			dispatch(
				updateSearchFilterSelectedOptionsThunk({
					searchFilterId: "property_category",
					newOptions: [
						{
							id: "residential",
							title: "Residential",
							value: "residential",
						},
					],
				}),
			),
				dispatch(
					updateSearchFilterSelectedOptionsThunk({
						searchFilterId: "property_type",
						newOptions: [
							{
								id: "apartment",
								title: "Apartment",
								value: "Apartment",
							},
						],
					}),
				),
				dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "property_category", isVisible: true }));
			dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "property_type", isVisible: true }));

			dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "property_category", isApplied: true }));
			dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "property_type", isApplied: true }));
			dispatch(
				updateSearchFilterSelectedOptionsThunk({
					searchFilterId: "transaction_type",
					newOptions: [
						{
							id: transactionType,
							title: transactionType.charAt(0).toUpperCase() + transactionType.slice(1),
							value: transactionType,
						},
					],
				}),
			);
			dispatch(
				updateSearchFilterAppliedThunk({
					searchFilterId: "transaction_type",
					isApplied: true,
				}),
			);
			dispatch(updateSearchFilterSelectedOptionsThunk({ searchFilterId: "business_profile_type", newOptions: [] }));
			dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "business_profile_type", isApplied: false }));
			setFilterChanged(true);
		} else if (newValue === "agents") {
			dispatch(
				updateSearchFilterSelectedOptionsThunk({
					searchFilterId: "transaction_type",
					newOptions: [],
				}),
			);
			dispatch(
				updateSearchFilterAppliedThunk({
					searchFilterId: "transaction_type",
					isApplied: false,
				}),
			);

			dispatch(updateSearchFilterSelectedOptionsThunk({ searchFilterId: "bedrooms_variant_2", newOptions: [] }));
			dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "bedrooms_variant_2", isApplied: false }));
			dispatch(updateSearchFilterSelectedOptionsThunk({ searchFilterId: "bathrooms_variant_2", newOptions: [] }));
			dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "bathrooms_variant_2", isApplied: false }));
			dispatch(updateSearchFilterSelectedOptionsThunk({ searchFilterId: "balconies_variant_2", newOptions: [] }));
			dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "balconies_variant_2", isApplied: false }));
			dispatch(updateSearchFilterSelectedOptionsThunk({ searchFilterId: "budget", newOptions: [] }));
			dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "budget", isApplied: false }));
			dispatch(
				updateSearchFilterAppliedThunk({
					searchFilterId: "search_type",
					isApplied: true,
				}),
			),
				dispatch(
					updateSearchFilterSelectedOptionsThunk({
						searchFilterId: "search_type",
						newOptions: [
							{
								id: "business_profiles",
								title: "Business Profiles",
								value: "business_profiles",
							},
						],
					}),
				),
				dispatch(
					updateSearchFilterSelectedOptionsThunk({
						searchFilterId: "business_profile_type",
						newOptions: [
							{
								id: "agents",
								title: "Agents",
								value: "agents",
							},
						],
					}),
				),
				dispatch(
					updateSearchFilterSelectedOptionsThunk({
						searchFilterId: "property_category",
						newOptions: [],
					}),
				),
				dispatch(
					updateSearchFilterSelectedOptionsThunk({
						searchFilterId: "property_type",
						newOptions: [],
					}),
				),
				dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "property_category", isApplied: false }));
			dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "property_type", isApplied: false }));

			dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "property_category", isVisible: false }));
			dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "property_type", isVisible: false }));
			dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "property_status", isVisible: false }));

			dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "service_category", isApplied: false }));
			dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "service_category", isVisible: false }));
			dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "service_subtype", isApplied: false }));

			dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "service_subtype", isVisible: false }));
			dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "service_type", isApplied: false }));
			dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "service_type", isVisible: false }));

			dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "business_profile_type", isApplied: true }));
			dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "business_profile_type", isVisible: true }));
			setFilterChanged(true);
		}
		// else if (newValue === "services") {
		// 	dispatch(updateSearchFilterSelectedOptionsThunk({ searchFilterId: "bedrooms_variant_2", newOptions: [] }));
		// 	dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "bedrooms_variant_2", isApplied: false }));
		// 	dispatch(updateSearchFilterSelectedOptionsThunk({ searchFilterId: "bathrooms_variant_2", newOptions: [] }));
		// 	dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "bathrooms_variant_2", isApplied: false }));
		// 	dispatch(updateSearchFilterSelectedOptionsThunk({ searchFilterId: "balconies_variant_2", newOptions: [] }));
		// 	dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "balconies_variant_2", isApplied: false }));
		// 	dispatch(updateSearchFilterSelectedOptionsThunk({ searchFilterId: "budget", newOptions: [] }));
		// 	dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "budget", isApplied: false }));
		// 	dispatch(
		// 		updateSearchFilterAppliedThunk({
		// 			searchFilterId: "search_type",
		// 			isApplied: true,
		// 		}),
		// 	),
		// 		dispatch(
		// 			updateSearchFilterSelectedOptionsThunk({
		// 				searchFilterId: "search_type",
		// 				newOptions: [
		// 					{
		// 						id: newValue,
		// 						title: newValue.charAt(0).toUpperCase() + newValue.slice(1),
		// 						value: newValue,
		// 					},
		// 				],
		// 			}),
		// 		);
		// 	dispatch(
		// 		updateSearchFilterSelectedOptionsThunk({
		// 			searchFilterId: "property_category",
		// 			newOptions: [],
		// 		}),
		// 	),
		// 		dispatch(
		// 			updateSearchFilterSelectedOptionsThunk({
		// 				searchFilterId: "property_type",
		// 				newOptions: [],
		// 			}),
		// 		),
		// 		dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "property_category", isApplied: false }));
		// 	dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "property_type", isApplied: false }));

		// 	dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "service_category", isApplied: true }));
		// 	dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "service_type", isApplied: true }));
		// 	dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "service_subtype", isApplied: true }));

		// 	dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "service_category", isVisible: false }));
		// 	dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "service_type", isVisible: true }));
		// 	dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "service_subtype", isVisible: true }));

		// 	dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "property_category", isVisible: false }));
		// 	dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "property_type", isVisible: false }));

		// 	dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "business_profile_type", isApplied: false }));
		// 	dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "business_profile_type", isVisible: false }));
		// 	dispatch(
		// 		updateSearchFilterSelectedOptionsThunk({
		// 			searchFilterId: "transaction_type",
		// 			newOptions: [],
		// 		}),
		// 	);
		// 	dispatch(
		// 		updateSearchFilterAppliedThunk({
		// 			searchFilterId: "transaction_type",
		// 			isApplied: false,
		// 		}),
		// 	);
		// 	dispatch(
		// 		setSearchAnimationDetailsThunk({
		// 			StartAnimate: true,
		// 			TriggerSearch: true,
		// 			PropertySubCategory: searchanimationsettings.PropertySubCategory,
		// 			ResetSearch: true,
		// 			HomeAccordion: false,
		// 			OpenLocationDrawer: false,
		// 		}),
		// 	);
		// 	dispatch(
		// 		setSearchFilterMetricesThunk({
		// 			boosted: [0],
		// 			non_boosted: [0],
		// 			filter_hash: "",
		// 			no_of_boosted_results: 0,
		// 			no_of_non_boosted_results: 0,
		// 			total_no_of_results: 0,
		// 			boosted_from_other_locations: [0],
		// 			no_of_boosted_from_other_locations: 0,
		// 		}),
		// 	);
		// }
	};

	const [transactionType, setTransactionType] = React.useState(
		search_filter_state.transaction_type.selected_options.length > 0
			? search_filter_state.transaction_type.selected_options[0].id
			: "buy",
	);

	const [openTransactionType, setOpenTransactionType] = React.useState(false);

	const handleChange = (event: { target: { value: string } }) => {
		setOpenTransactionType(false);
		ClearAllDefaultFilters();
		setTransactionType(event.target.value);
		dispatch(
			updateSearchFilterAppliedThunk({
				searchFilterId: "transaction_type",
				isApplied: true,
			}),
		);
		dispatch(
			updateSearchFilterSelectedOptionsThunk({
				searchFilterId: "transaction_type",
				newOptions: [
					{
						id: event.target.value,
						title: event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1),
						value: event.target.value,
					},
				],
			}),
		);
		dispatch(
			updateSearchFilterSelectedOptionsThunk({
				searchFilterId: "property_category",
				newOptions: [
					{
						id: "residential",
						title: "Residential",
						value: "residential",
					},
				],
			}),
		),
			dispatch(
				updateSearchFilterSelectedOptionsThunk({
					searchFilterId: "property_type",
					newOptions: [],
				}),
			),
			dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "property_category", isVisible: true }));
		dispatch(updateSearchFilterVisibilityThunk({ searchFilterId: "property_type", isVisible: true }));

		dispatch(
			updateSearchFilterActiveOptionsThunk({
				searchFilterId: "property_type",
				newOptions: residential_options_active,
			}),
		);
		dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "property_category", isApplied: true }));
		dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "property_type", isApplied: false }));
		dispatch(updateSearchFilterAppliedThunk({ searchFilterId: "business_profile_type", isApplied: false }));
		setFilterChanged(true);
	};

	/*

	* select icon functional state

	*/

	const CustomIconComponent = ({ className, ...props }: IconProps) => {
		const isOpen = props["data-mui-select-open"] ?? false;

		const Icon = isOpen ? ExpandLessIcon : ExpandMoreIcon;

		return <Icon className={className} />;
	};

	React.useEffect(() => {
		if (isBeegruAvailable !== "" && isBeegruAvailable === "not_available") {
			setState({ ...state, open: true });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isBeegruAvailable]);

	const handleExited = () => {
		setIsBeegruAvailable("");
	};
	React.useEffect(() => {
		if (FilterChanged) {
			PpsfFilterGenertateUrl(search_filter_state, router);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [FilterChanged]);
	return (
		<React.Fragment>
			<Snackbar
				anchorOrigin={{ vertical, horizontal }}
				open={open}
				onClose={handleClose}
				autoHideDuration={1875}
				TransitionProps={{
					onExited: handleExited,
				}}
				sx={{
					"& .MuiSnackbarContent-root": {
						backgroundColor: "#fde3de",
						color: "#5F2B01",
						fontSize: "1rem",
						fontWeight: 500,
						borderRadius: "0.75rem",
					},
				}}
				message={
					<SnackbarDiv>
						<WarningAmberOutlinedIcon sx={{ color: "#F44336" }} />
						<Box
							sx={{
								padding: "0.5rem 0.75rem",
							}}
						>
							<Typography
								sx={{
									color: "#621B16",
									fontSize: "1rem",
									fontWeight: 500,
								}}
							>
								{isBeegruAvailable === "not_available"
									? "Location unserviceable !"
									: router.locale === "ar-AE"
										? "يرجى إدخال الموقع"
										: router.locale === "kn-IN"
											? "ದಯವಿಟ್ಟು ಸ್ಥಳವನ್ನು ನಮೂದಿಸಿ"
											: "Please enter a location"}
							</Typography>
							<Typography
								sx={{
									color: "#621B16",
									fontSize: "0.875rem",
									fontWeight: 400,
								}}
							>
								{isBeegruAvailable === "not_available" && (LOCATION_UNAVAILABLE_MESSAGE_LOCALES[router.locale || "en-IN"] || LOCATION_UNAVAILABLE_MESSAGE_LOCALES["en-IN"])}
							</Typography>
						</Box>
					</SnackbarDiv>
				}
				key={`${vertical}-${horizontal}`}
			/>

			<FixedWrapper>
				<MainContainer>
					<div>
						<SearchTypeTabs
							value={value}
							onChange={handleChangeSearchTypeTabs}
							variant="standard"
							TabIndicatorProps={{
								style: { backgroundColor: "#B05911" },
							}}
						>
							<SearchTypeTab
								disableFocusRipple
								disableRipple
								value="properties"
								label="Properties"
							/>
							{/* <SearchTypeTab
								disableFocusRipple
								disableRipple
								value="services"
								label="Services"
							/> */}
							<SearchTypeTab
								disableFocusRipple
								disableRipple
								value="agents"
								label="Agents"
							/>
						</SearchTypeTabs>
					</div>
					<div
						style={{
							display: "flex",
							width: "100%",
							justifyContent: "flex-start",
							alignItems: "center",
							gap: "0.5rem",
						}}
					>
						{search_filter_state?.search_type.selected_options[0].id === "properties" && (
							<>
								<Select
									id="home_desktop_transaction_type_select"
									value={transactionType}
									onChange={handleChange}
									onOpen={() => setOpenTransactionType(true)}
									onClose={() => setOpenTransactionType(false)}
									displayEmpty
									IconComponent={CustomIconComponent}
									MenuProps={{
										PaperProps: {
											sx: {
												boxShadow: "none",
												border: "1px solid #ddd",
											},
										},
										disableScrollLock: true,
									}}
									sx={{
										width: "15%",
										backgroundColor: "white",
										"& .MuiOutlinedInput-notchedOutline": {
											border: "none",
										},
										"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
											border: "none",
										},
										"& .MuiSelect-select": {
											display: "flex",
											alignItems: "center",
											padding: "0rem 0rem 0rem 0.25rem",
										},
										"& .MuiInputBase-root": {
											display: "flex",
											alignItems: "center",
										},
									}}
								>
									<MenuItem
										id="home_desktop_transaction_type_buy"
										value="buy"
									>
										Buy
									</MenuItem>
									<MenuItem
										id="home_desktop_transaction_type_rent"
										value="rent"
									>
										Rent
									</MenuItem>
									{/* <MenuItem
										id="home_desktop_transaction_type_resale"
										value="resale"
									>
										Resale
									</MenuItem> */}
								</Select>
								<Divider
									orientation="vertical"
									variant="middle"
									flexItem
								/>
							</>
						)}

						<div
							style={{
								display: "flex",
								width: "100%",
								gap: "1rem",
							}}
						>
							<LocationAutoComplete
								search_id="location"
								dispatch={dispatch}
								location={search_filter_state.location}
								searchLocation={searchLocation}
								// searchanimationsettings={searchanimationsettings}
								setIsBeegruAvailable={setIsBeegruAvailable}
								isBeegruAvailable={isBeegruAvailable}
								search_filter_state={search_filter_state}
							/>

							<BeegruButton
								id={"home_desktop_search_button"}
								variant="contained"
								size="large"
								onClick={() => {
									if (
										!search_filter_state.location.is_applied ||
										isBeegruAvailable === "not_available" ||
										isBeegruAvailable === "no_location"
									) {
										setState({
											open: true,
											vertical: "top",
											horizontal: "center",
										});
									} else if (isBeegruAvailable === "available") {
										PpsfFilterGenertateUrl(search_filter_state, router);
									}
								}}
							>
								{router.locale === "ar-AE" ? "بحث" : router.locale === "kn-IN" ? " ಹುಡುಕಿ" : "Search"}
							</BeegruButton>
						</div>
					</div>
				</MainContainer>
			</FixedWrapper>
		</React.Fragment>
	);
};

export default SearchAfterAnimationComponent;
